export default __webpack_public_path__ + "static/media/titre_mobile.cad59006.svg";